import React, { useState } from 'react';
import axios from 'axios';
import { Ruler } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from 'react-i18next';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const MeasurementSystemToggle = ({ token }) => {
  const { t } = useTranslation();
  const { user, fetchUser } = useAuth();
  const currentSystem = user?.measurement_system || user?.profile?.measurement_system || 'metric';
  const [saving, setSaving] = useState(false);

  const toggleSystem = async (newSystem) => {
    if (newSystem === currentSystem) return;
    setSaving(true);
    try {
      await axios.put(`${API}/profile/measurement-system?system=${newSystem}`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      await fetchUser();
    } catch (e) {
      console.error('Failed to update measurement system:', e);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white dark:bg-gray-800 p-5 rounded-xl shadow-sm" data-testid="measurement-system-settings">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-orange-100 dark:bg-orange-900/30 rounded-full flex items-center justify-center">
            <Ruler size={20} className="text-[#FF6600]" />
          </div>
          <div>
            <h3 className="font-bold text-gray-900 dark:text-white">{t('settings.measurementSystem')}</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400">{t('settings.measurementDesc')}</p>
          </div>
        </div>
        <div className="inline-flex rounded-lg border border-gray-300 dark:border-gray-600 overflow-hidden" data-testid="measurement-system-selector">
          <button
            onClick={() => toggleSystem('metric')}
            disabled={saving}
            className={`px-5 py-2 text-sm font-semibold transition-colors ${
              currentSystem === 'metric'
                ? 'bg-[#FF6600] text-white'
                : 'bg-white dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:bg-gray-900 dark:hover:bg-gray-600'
            }`}
            data-testid="setting-metric-btn"
          >
            {t('settings.metricLabel')}
          </button>
          <button
            onClick={() => toggleSystem('imperial')}
            disabled={saving}
            className={`px-5 py-2 text-sm font-semibold transition-colors ${
              currentSystem === 'imperial'
                ? 'bg-[#FF6600] text-white'
                : 'bg-white dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:bg-gray-900 dark:hover:bg-gray-600'
            }`}
            data-testid="setting-imperial-btn"
          >
            {t('settings.imperialLabel')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MeasurementSystemToggle;
